import { featureEntryLabel, type FeatureEntry } from "@/lib/labServices";
import { Badge } from "@/ui/Badge";

function Group({
  title,
  entries,
}: {
  title: string;
  entries: readonly FeatureEntry[];
}) {
  return (
    <div className="mt-1">
      <p className="text-xs text-muted-foreground">{title}</p>
      {entries.length === 0 ? (
        <p className="text-sm text-muted-foreground">None recorded.</p>
      ) : (
        <ul className="mt-1 flex flex-wrap gap-2">
          {entries.map((entry) => (
            <li key={entry.name}>
              <Badge tone="outline">
                <span dir="ltr">{featureEntryLabel(entry)}</span>
              </Badge>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

/**
 * What decided each feature of a run: the pack's brain features and the run
 * options for the services, each with its value and where the value came from
 * (pack, run option, tenant, default, forced off).
 */
export function LabFeatureGroups({
  features,
  serviceFlags,
}: {
  features: readonly FeatureEntry[];
  serviceFlags: readonly FeatureEntry[];
}) {
  return (
    <>
      <Group title="Pack features (brain)" entries={features} />
      <Group title="Run options (services)" entries={serviceFlags} />
    </>
  );
}
